import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import Restaurant from '../../../app/data/models/restaurant';

interface DrawerRestaurantState {
  selectedRestaurant:
    | { id: string; name: string; logoUrl?: string }
    | undefined;
  status: 'idle' | 'pending' | 'succeeded' | 'failed';
}

const initialState: DrawerRestaurantState = {
  selectedRestaurant: undefined,
  status: 'idle',
};

export const fetchDrawerRestaurantConfigAsync = createAsyncThunk<
  Restaurant,
  string
>('drawerRestaurant/fetchConfig', async (restaurantId, thunkApi) => {
  try {
    return await api.Restaurant.config(restaurantId);
  } catch (error: unknown) {
    return thunkApi.rejectWithValue({ error: error.data });
  }
});

export const drawerRestaurantSlice = createSlice({
  name: 'drawerRestaurant',
  initialState,
  reducers: {
    setDrawerSelectedRestaurant: (
      state,
      action: PayloadAction<
        { id: string; name: string; logoUrl?: string } | undefined
      >
    ) => {
      state.selectedRestaurant = action.payload;
    },
    resetDrawerSelectedRestaurant: (state) => {
      state.selectedRestaurant = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDrawerRestaurantConfigAsync.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchDrawerRestaurantConfigAsync.fulfilled, (state, action) => {
        state.selectedRestaurant = {
          id: action.payload.id,
          name: action.payload.name,
          logoUrl: action.payload.logoUrl,
        };
        state.status = 'succeeded';
      })
      .addCase(fetchDrawerRestaurantConfigAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { setDrawerSelectedRestaurant, resetDrawerSelectedRestaurant } =
  drawerRestaurantSlice.actions;
